import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    onBehalfOfMinor: false,
    vehicle: "",
  },
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    updateData: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    updateFund: (state, action) => {
      const indexOfFund = state.value.funds.findIndex(
        (f) => f.fund.id === action.payload.id
      );

      state.value.funds[indexOfFund] = {
        ...state.value.funds[indexOfFund],
        ...action.payload.data,
      };
    },
    resetData: (state, action) => {
      state.value = {};
      localStorage.removeItem("invest.fairtree.com");
    },
  },
});

export const { updateData, updateFund, resetData } = dataSlice.actions;

export default dataSlice.reducer;
